import PrintActions from '../../../actions/PrintActions';

class EmailReceipt extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: props.email,
        };

        this.isValid = this.isValid.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
    }

    isValid() {
        return this.validateEmail(this.state.email);
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    render() {

        return (
            <div style={{ margin: 10 }}>
                <div className={'input-profile' + (!this.isValid() ? '__error ' : ' ' )}>

                    <div className='input-profile__title'>
                         Send Receipt To
                    </div>
                    <input 
                        value={this.state.email}
                        onChange={(x) => { this.setState({email: x.target.value}); }}
                    />
                </div>

                <div className='row' style={{margin:0}}>
                    <div
                        className='checkout-overdue__btn checkout-overdue__no'
                        onClick={() => { this.props.onDone(); }}>

                        Cancel
                    </div>

                    <div
                        className={`checkout-overdue__btn checkout-overdue__yes ${ !this.isValid() ? 'checkout-overdue__disabled' : '' }`}
                        onClick={() => { 

                            if(this.isValid()) {
                                PrintActions.emailReceipt(this.props.ShipmentId, this.state.email, 'Checkout');
                                this.props.onDone();
                            }
                        }}>

                        Send
                    </div>
                </div>
            </div>
        );
    }
}

export default EmailReceipt;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/EmailReceipt.react.jsx